export default __webpack_public_path__ + "static/STARS-e1bc65d6b147ffabe37df8af30f01f4a.png";